// @flow
import { type JSSThemeDefaultBetslipType } from '../JSSThemeDefaultBetslip';

export const JSSThemeBetslip: JSSThemeDefaultBetslipType = (themeVars) => {
  const {
    fontSizes,
    margins,
    colors: {
      colorTypes: {
        error,
        text1,
        text3,
        neutral1,
        white,
        border2,
        background5,
      },
    },
  } = themeVars;
  return {
    Betslip: {
      root: {
        background: background5,
        boxShadow: 'none',
        paddingTop: margins.xs,
      },
      info: {
        background: 'transparent',
      },
    },
    BetslipTotals: {
      root: {
        borderTop: `none`,
      },
      summaryValue: {
        fontSize: fontSizes.lg,
        fontWeight: 'normal',
      },
    },
    BetslipSelection: {
      common: {
        background: border2,
        borderRadius: '2px',
      },
    },
    EachWayButton: {
      root: {
        color: text3,
      },
      label: {
        '&:after': {
          border: `2px solid ${white}`,
        },
        '&:before': {
          border: `1px solid ${border2}`,
          background: neutral1,
        },
      },
    },
    BetslipErrors: {
      list: {
        borderRadius: 0,
        background: text1,
      },
      listItem: {
        color: error,
      },
    },
    BetslipInput: {
      container: {
        background: border2,
        borderRadius: '0 0 2px 2px',
        padding: [margins.xs, 0, 0],
      },
      label: {
        color: text3,
        fontSize: fontSizes.sm,
        padding: '0 0 5px',
      },
    },
    NonSingleBody: {
      selectionInfo: {
        color: text3,
      },
    },
    TextPair: {
      row: {
        color: text3,
      },
    },
    SingleSelectionStaticInfo: {
      marketDescription: {
        fontSize: fontSizes.sm,
        paddingTop: margins.xs,
      },
      priceDescription: {
        fontSize: fontSizes.sm,
      },
      eventDescription: {
        fontSize: 13,
      },
    },
    SingleSelectionInfo: {
      marketDescription: {
        fontSize: fontSizes.sm,
        color: text3,
      },
      priceDescription: {
        fontSize: fontSizes.sm,
        color: text3,
      },
      info: {
        fontSize: '13px',
      },
      eventDescription: {
        color: text3,
      },
      remove: {
        color: text3,
      },
    },
    Receipt: {
      root: {
        background: background5,
        boxShadow: '0 0 6px #0000003d',
      },
      controls: {
        background: background5,
      },
    },
    ShareBets: {
      message: {
        '&.shown': {
          color: error,
        },
      },
      shareIcon: {
        marginLeft: '-4px',
        marginTop: '-3px',
      },
    },
  };
};
